// helper functions to toggle a class name on an element
function removeClass(el, classname) {
    el.className = el.className.replace(" " + classname, "");
    el.className = el.className.replace(classname, "");
}
function addClass(el, classname) {
    el.className += " " + classname;
}
function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

// global vars
var sliderImgs = document.querySelectorAll('.mu-magslider .imgContainer .wp-post-image');
var header = document.getElementById('header');

// determine whether logo text should be dark or light
function darkOrLight(index) {
    var img = sliderImgs[index];
    if (!hasClass(img, 'dark') && !hasClass(header, 'light')) {
        removeClass(header, 'dark');
        addClass(header, 'light');
    } else if (hasClass(img, 'dark') && !hasClass(header, 'dark')) {
        removeClass(header, 'light');
        addClass(header, 'dark');
    }
}
// enable flickity for homepage slider
var hpSlider = document.querySelector('.mu-magslider');
if (hpSlider) {
    new Flickity(hpSlider, {
        cellSelector: '.carousel-cell',
        adaptiveHeight: true,
        imagesLoaded: true,
        wrapAround: true,
        pageDots: false,
        on: {
            ready: function () {
                addClass(hpSlider, 'ready');
            },
            settle: function (index) {
                if (hasClass(hpSlider, 'unsettled')) {
                    removeClass(hpSlider, 'unsettled');
                }
            },
            change: function (index) {
                // NOTE: disabled until imagick supported in php 8
                // darkOrLight(index)
                if (!hasClass(hpSlider, 'unsettled')) {
                    addClass(hpSlider, 'unsettled');
                }
            }
        }
    });
}
